import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalDialogService {
  private modalState = new BehaviorSubject<{ component: any; data: any } | null>(null);
  modalState$ = this.modalState.asObservable();

  openModal(component: any, data: any = null) {
    this.modalState.next({ component, data });
  }

  closeModal() {
    this.modalState.next(null);
  }
}
